import React, { Component } from "react";
import { connect } from "react-redux";

class Header extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <header className={`header ${this.props.parentCssClass}`}>
        <div className={this.props.childCssClass}>
          <h1>{this.props.title}</h1>
          <p className="zeta">
            {this.props.text}
          </p>
          <img src={this.props.mobileImg} />
        </div>
      </header>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

// Get actions and pass them as props to to UserList
//      > now UserList has this.props.selectUser

export default connect(mapStateToProps)(Header);
